import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import axios from 'axios';
import { Button} from 'reactstrap';
import { Colors, Styles, tableStyles } from '../../../../src/styles/theme';

/* import ReactPaginate from 'react-paginate'; */


class ContributorList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      count: 0,
      pageCount: 0,
      perPage: 10, // Quantidade de Usuários por página
      skip: 0,
      id: '',
      name: '',
      email: '',
      active: '',
      password: '',
      codeS4:'',      
      image: '',
      type: 'ADMIN',
      tituloDialog: 'Novo',
      modalOpen: false,
      loadingSave: false,
      success: null,
      emailError: {
        display: 'none',
        msg: ''
      },
      showTable: false

    };

    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      titleTable: {
        textAlign: 'center',
        padding: 0
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      inputs: {
        marginLeft: 10,
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      name: '',
      email: '',
      password: '',
      type: '',
      codeS4: ''

    };

    this.errorFormat = {
      email: ''
    };

    this.localUserData = {
      token: localStorage.getItem('dental_t')
    };

    this.userType = {
      'ADMIN': 'Administrador',
      'SUPERVISOR': 'Supervisor',
      'REGISTER': 'Cadastro',
      'AFTER SALES': 'Pós Venda',
      'PJCADASTRO': 'PJCadastro',
      'FINANCEIRO': 'Financeiro'
    };
    this.userStatus = {
      true : 'ATIVO',
      false : 'INATIVO'
    };    
  }

  componentDidMount() {
    this.getData(urlBase.loopBack + 'Accounts?filter={"where":{"or":[{"type":"FINANCEIRO"},{"type":"ADMIN"},{"type":"SUPERVISOR"},{"type":"REGISTER"},{"type":"AFTER SALES"},{"type":"PJCADASTRO"}]}}&access_token=' + this.localUserData.token);
  }

  getData(url) {
    axios.get(url)
    .then((response) => {
      let state = this.state;

      if (response.data.length == 0)
        state.data = 'zero';
      else
        state.data = response.data;
      
      for (let i = 0; i < state.data.length; i++) {
        state.data[i].type = this.userType[state.data[i].type];
        state.data[i].active = this.userStatus[state.data[i].active];
      }
      if (state.showTable == false) {
        state.showTable = true;

        $(document).ready( function () {
          $('#table_id').DataTable({
            "language": {
              "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
            },
            "order": [[0, "asc"]],
            lengthMenu: [
              [10, 25, 50, 100, -1],
              ['10', '25', '50', 100, 'Todas']
            ]
          });
        });
      }
      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  // Monitora mudanças a atualiza estados do Select 'Tipo'
  typeChange(event, index, payload) {
    let state = this.state;
    state.type = payload;
    this.setState(state);
  }

  onBlurField(e) {
    let state = this.state;
    state.emailError.display = 'none';
    state.emailError.msg = '';
    this.setState(state);

    if (e.target.type == 'email') {
      if (!e.target.validity.valid)
        this.errorFormat.email = 'Formato esperado: email@exemplo.com';
      else {
       // this.onBlurEmail(e);
        this.errorFormat.email = '';
      }
    }
  }

  fileToBase64() {
    let reader = new FileReader();
    let file = document.getElementById('file_image').files[0];

    reader.onloadend = function() {
      document.getElementById('image_64').value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  addUser() {
    let erro = this.errorField;
    erro.name = '';
    erro.email = '';
    erro.password = '';
    erro.type = '';
    this.setState(erro);
    
    let state = this.state;
    state.id = '';
    state.name = '';
    state.email = '';
    state.password = '';
    state.image = '';
    state.type = '';   
    state.active = true;
    state.codeS4 = '';
    state.tituloDialog = 'Novo';
    state.success = null;
    this.state.emailError.msg ='';
    state.modalOpen = true;
    this.setState(state);
  }

  saveUser() {
    let state = this.state;
    let isNewPassword = false;

    let dataPost = [];
    if (state.tituloDialog === 'Alterar') {
      dataPost = {
        id : this.state.id, 
        name: this.state.name,
        email: this.state.email,
        password: this.state.password,
        active: this.state.active,
        image: document.getElementById('image_64').value,
        type: this.state.type,
        codeS4 : this.state.codeS4

      };        
    } else {
        if (this.state.password == '')
            isNewPassword = true;
        dataPost = {
        name: this.state.name,
        email: this.state.email,
        active: this.state.active,
        password: this.state.password,
        image: document.getElementById('image_64').value,
        type: this.state.type,
        codeS4 : this.state.codeS4

      };        
    }  


    if (state.name.length != 0 &&
          state.email.length != 0 &&
          state.type.length != 0 &&
          state.email.length != 0 &&
          !isNewPassword   ) {

      state.loadingSave = true;

      this.setState(state);
  

      let url = urlBase.loopBack + '/Accounts/saveUserImage';
      
      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
       // this.stateDefault();
      })
      .catch(function (error) {
        let state = this.state;
        state.success = false;
        state.loadingSave = false;

        if (error.message.indexOf("422") != -1) {
          state.emailError.msg = "E-mail já em uso por outro usuário.";
        }
        this.setState(state);        


      }.bind(this));
    }
    else {
         alert('Necessário preencher os campos obrigatórios de forma correta.');
         let state = this.state;
         state.emailError.msg = '';
         this.setState(this.state);

    }

  }

  stateDefault() {
    let state = this.state;
    state.name = '',
    state.email = '',
    state.password = '',
    state.image = '',
    state.type = '',
    state.emailError = {
      display: 'none',
      msg: ''
    };

    this.setState(state);
  }

  onBlurEmail(e) {
    // Paulo - Avaliar a necessidade desse método
    if (e.target.value.length > 0) {
      let url = urlBase.loopBack + 'Accounts/count?where={"email":"'+e.target.value+'"}'+'&access_token='+localStorage.getItem('dental_t');
      axios.get(url)
      .then((response) => {
        let state = this.state;
        // Se encontrar pelo menos um vendedor ou mais com mesmo email
        if (response.data.count > 0 )  {
          state.emailError.display = 'block';
          state.emailError.msg = 'Email já em uso.';
        }
        else {
          state.emailError.display = 'none';
          state.emailError.msg = '';
        }
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.emailError.display = 'block';
        state.emailError.msg = 'Erro ao verificar o email';
        this.setState(state);
      }.bind(this));
    }
  }
  handleChange(e, _name, event, index, _value){
    let state = this.state;
    state.active = _value;
    this.setState(state); 
  }
  handleModalClose() {
    let state = this.state;
    state.loadingSave = false; 
    state.emailError.msg = '';
    this.setState(state);
    this.setState({modalOpen: false});
    //this.getData(urlBase.loopBack + 'Accounts?filter={"where":{"or":[{"type":"ADMIN"},{"type":"SUPERVISOR"},{"type":"REGISTER"},{"type":"AFTER SALES"}]}}&access_token=' + this.localUserData.token);
    this.getData(urlBase.loopBack + 'Accounts?filter={"where":{"or":[{"type":"ADMIN"},{"type":"SUPERVISOR"},{"type":"REGISTER"},{"type":"AFTER SALES"},{"type":"PJCADASTRO"}]}}&access_token=' + this.localUserData.token);

  }

  edit(id) {
    let url = urlBase.loopBack + 'Accounts?filter={"where":{"_id" : "'+ id + '"}}&access_token='+ this.localUserData.token;
    axios.get(url).then((data) => {

      const usuario = data.data[0];
      let erro = this.errorField;
      erro.name = '';
      erro.email = '';
      erro.password = '';
      erro.type = '';
      this.setState(erro);

      let state = this.state;
      state.name = usuario.name;
      state.id = usuario.id;
      state.email = usuario.email;
      state.type = usuario.type;
      state.active = usuario.active;
      state.codeS4 = usuario.codeS4;
      state.tituloDialog = 'Alterar';
      this.state.emailError.msg ='';
      state.success = null;
      state.modalOpen = true;
      this.setState(state);

    })
    .catch(function (error) {
      alert(error.message)
      let state = this.state;
      state.error = error.message;
      state.data = 'error';
      this.setState(state);
    }.bind(this)); 
  
  }


  render() {

    return (
      <div>
          <style>{tableStyles}</style>   
            {/* CABEÇALHO DA PÁGINA COM BOTÃO ADICIONAR */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              marginBottom: '20px',
              paddingLeft: '10px' 
            }}>
              <h2 style={{ 
                margin: 0, 
                fontSize: '1.4rem', 
                color: Colors.textDark, 
                fontWeight: 500,
                textTransform: 'uppercase' 
              }}>
                Gerenciar Colaboradores
              </h2>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                onClick={this.addUser.bind(this)}
              >
                Novo Colaborador
            </Button>        

            </div>
            
              {
                this.state.data == 'loading' ? (
              <div style={{textAlign: 'center'}}>
                <CircularProgress />
                <p>Carregando...</p>
              </div>
                ) : (
                  this.state.data == 'error' ? (
              <p style={this.styles.error}>
                Erro ao buscar dados.
              </p>
                  ) : (
                    this.state.data == 'zero' ? (
              <div style={this.styles.zero}>
                <p>Nenhuma proposta encontrada.</p>
              </div>
                    ) : (
              <div>
                <Paper style={{overflow: 'auto', marginLeft: 10, borderRadius:10 }}>
                
                    <table
                      id="table_id"
                      className="table-striped dataTable"
                      style={{ width: '100%' }} >
                    <thead>
                      <tr>
                        <th>Colaborador</th>
                        <th>E-mail</th>
                        <th>Tipo</th>                 
                        <th>Status</th>
                        <th>Ação</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.data.map((item, index) =>
                      <tr
                        key={index}style={item.active == 'ATIVO' ? ( {padding:0}) : ({padding:0, color: 'rgb(244, 67, 54)'})}
                        className="row_table"
                      >
                        <td >{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.type}</td>
                        <td>
                                  <span style={{
                                    padding: '4px 8px',
                                    borderRadius: '12px',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    backgroundColor: item.active == 'ATIVO' ? Colors.statusAtivoBg : Colors.statusInativoBg,
                                    color: item.active == 'ATIVO' ? Colors.statusAtivoText : Colors.statusInativoText
                                  }}>
                                    {item.active}
                                  </span>
                        </td>                                              

                        
                        <td onClick={this.edit.bind(this, item.id)}
                            style={{cursor:'pointer', padding:0}}>
                          <i className="fas fa-edit">&nbsp;</i>
                        </td>                  
                      </tr>
                      )}
                    </tbody>

                  </table>
            
                </Paper>
                
                <Dialog
                  
                    title={
                                  <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '16px 24px',
                                    backgroundColor: Colors.backgroundLight,
                                    borderBottom: `1px solid ${Colors.borderLight}`,
                                    borderRadius: '8px 8px 0 0'
                                  }}>
                                    <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                                      {this.state.tituloDialog} Colaborador
                                    </span>
                                    <img
                                      style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                                      src={urlBase.client + '/assets/images/icons/icon_close.png'}
                                      onClick={this.handleModalClose.bind(this)}
                                    />
                                  </div>
                                }
                                titleStyle={{ padding: 0 }}
                                bodyStyle={{ padding: '24px' }}
                                modal={false}
                                open={this.state.modalOpen}
                                onRequestClose={this.handleModalClose.bind(this)}
                                autoScrollBodyContent={true}
                                contentStyle={{ width: '90%', maxWidth: '700px', borderRadius: '8px', overflow: 'hidden' }}
                              > 
                  <div>
                    {/* Mensagem de retorno do formulário */
                      this.state.success != null ? (
                        this.state.success == true ? (/* Formulário salvo com sucesso */
                      <Grid container spacing={24} style={{marginTop:30}}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div style={{textAlign: 'center'}}>
                            <p style={this.styles.sendFormSuccess}>Colaborador salvo com sucesso</p>
                          </div>
                        </Grid>
                      </Grid>
                        ) : (/* Erro ao enviar formulário */
                      <Grid container spacing={24} style={{marginTop:30}}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div style={{textAlign: 'center'}}>
                            <p style={this.styles.sendFormError}>{this.state.emailError.msg}</p>
                          </div>
                        </Grid>
                      </Grid>
                        )
                      ) : ('')
                    }

                    {/* Loading de salvar o formulário*/
                      this.state.loadingSave == true ? (
                    <div id="loading_form">
                      <Grid container spacing={24} style={{marginTop:30}}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div style={{textAlign: 'center'}}>
                            <CircularProgress />
                            <p>Enviando...</p>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                      ) : (/* Formulário*/
                    <div id="form">
                      <Grid container spacing={24}>
        
                        <Grid item xs={12} sm={12} md={12} lg={6}>
                          <TextField
                            errorText={this.errorField.name}
                            style={this.styles.inputs}
                            hintText="Nome"
                            floatingLabelText="Nome *"
                            type="text"
                            name="name"
                            value={this.state.name}
                            fullWidth={true}
                            required
                            onChange={(e) => this.onChange(e)}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6}>
                              <SelectField
                              floatingLabelText="STATUS *"
                              fullWidth={true}
                              name="status"
                              errorText={this.errorField.status}
                              value={this.state.active}
                              onChange={this.handleChange.bind(this, null, 'status')}                      >
                              <MenuItem value={true} label={"ATIVO"}  primaryText={"ATIVO"} />
                              <MenuItem value={false} label={"INATIVO"}  primaryText={"INATIVO"} />
                            </SelectField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            errorText={this.errorFormat.email}
                            style={this.styles.inputs}
                            hintText="E-mail"
                            floatingLabelText="E-mail *"
                            type="email"
                            name="email"
                            value={this.state.email}
                            fullWidth={true}
                            onChange={(e) => this.onChange(e)}
                            onBlur={(e) => this.onBlurField(e)}
                          />
                          <p style={{
                            paddingLeft: 10,
                            color: 'rgb(244, 67, 54)',
                            fontSize: 12,
                            margin:0,
                            display: this.state.emailError.display}}
                          >
                            {this.state.emailError.msg}
                          </p>
                        </Grid>
        
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            errorText={this.errorField.password}
                            style={this.styles.inputs}
                            hintText="Senha"
                            floatingLabelText="Senha *"
                            type="password"
                            name="password"
                            value={this.state.password}
                            fullWidth={true}
                            onChange={(e) => this.onChange(e)}
                          />
                        </Grid>
        
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <input id="image_64" type="hidden"/>
                          <label style={{paddingLeft: 10}}>Foto:</label>
                          <br/>
                          <input
                            id="file_image"
                            type="file"
                            name="image"
                            style={{paddingLeft: 10}}
                            onChange={this.fileToBase64.bind(this)}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <SelectField
                            errorText={this.errorField.type}
                            style={this.styles.inputs}
                            floatingLabelText="Tipo *"
                            fullWidth={true}
                            name="type"
                            value={this.state.type}
                            onChange={this.typeChange.bind(this)}
                          >
                            <MenuItem value={"ADMIN"} primaryText="ADMINISTRADOR" />
                            <MenuItem value={"SUPERVISOR"} primaryText="SUPERVISOR" />
                            <MenuItem value={"REGISTER"} primaryText="CADASTRO" />
                            <MenuItem value={"AFTER SALES"} primaryText="PÓS-VENDA" />
                            <MenuItem value={"PJCADASTRO"} primaryText="PJCADASTRO" />
                            <MenuItem value={"FINANCEIRO"} primaryText="FINANCEIRO" />
                          </SelectField>
                        </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            //errorText={this.errorField.codeS4}
                            style={this.styles.inputs}
                            hintText="Código S4"
                            floatingLabelText="Código S4*"
                            type="text"
                            name="codeS4"
                            value={this.state.codeS4}
                            fullWidth={true}
                            onChange={(e) => this.onChange(e)}
                          />
                        </Grid>                   
                      </Grid>
                      {/* --- RODAPÉ DE AÇÕES --- */}
                      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                          type="button"
                          onClick={this.handleModalClose.bind(this)}
                          style={{ 
                            ...Styles.buttonCancel, 
                            backgroundColor: Colors.textLight, // Usando cinza para cancelar
                            textTransform: 'none' 
                          }}
                        >
                          Cancelar
                        </button>
                        <button
                          type="button"
                          onClick={this.saveUser.bind(this)}
                          style={{ 
                            ...Styles.buttonSuccess, 
                            fontWeight: 'bold', 
                            textTransform: 'none' 
                          }}
                        >
                          Salvar 
                        </button>
                      </div>

                    </div>
                      )
                    /*#form*/}

                  </div>
                </Dialog>

              </div>
                    )
                  )
                )
              }
      </div>
    );

  }

}

export default ContributorList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Contributors/ContributorList.js
 **/